import React, { useState } from 'react';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import AnalyticsCard from '../../../components/Analytics/AnalyticsCard/AnalyticsCard';
import GenericLineChart from '../GenericLineChart/GenericLineChart';
import CategoryResponse from '../../../types/Analytics/CategoryResponse';

interface TopicsChartProps {
  dateRange: [dayjs.Dayjs | null, dayjs.Dayjs | null];
  topicsData: CategoryResponse[] | undefined;
  isLoading: boolean;
  isSmallScreen: boolean;
  hideLegend?: boolean;
  selectedGroups?: string[];
  onGroupsChange?: (groups: string[]) => void;
}

function TopicsChart({
  dateRange,
  topicsData,
  isLoading,
  isSmallScreen,
  hideLegend,
  selectedGroups: externalSelectedGroups,
  onGroupsChange
}: TopicsChartProps): React.ReactElement {
  const [internalSelectedGroups, setInternalSelectedGroups] = useState<
    string[]
  >([]);
  const [groupNames, setGroupNames] = useState<string[]>([]);

  const selectedGroups = externalSelectedGroups ?? internalSelectedGroups;

  const handleDataProcessed = (
    groups: string[],
    initialSelection: string[]
  ): void => {
    setGroupNames(groups);
    if (!externalSelectedGroups) {
      setInternalSelectedGroups(initialSelection);
    }
  };

  return (
    <AnalyticsCard
      isLoading={isLoading}
      title='Topics over time'
      tooltipText='Topics matched during the selected period. Hover over the data points for more information.'
      className='pb-4'
      style={{ height: 530 }}
      content={
        topicsData?.length && topicsData.length > 0 ? (
          <GenericLineChart
            height={430}
            dateRange={dateRange}
            data={topicsData}
            dateKey='date'
            groupKey='category'
            countKey='categoryCount'
            isSmallScreen={isSmallScreen}
            selectedGroups={selectedGroups}
            onDataProcessed={handleDataProcessed}
            hideLegend={hideLegend}
          />
        ) : (
          <Typography variant='body2' sx={{ textAlign: 'center', m: 2 }}>
            No topics have been matched during this date range.
          </Typography>
        )
      }
    />
  );
}

export default TopicsChart;
